
export const REGISTRATION_CODES =
{
  MC: {
    MAN: "carrierUsDotNumber",
    MAA: "carrierName",
    MAK: "mailingAddressStreet",
    MAL: "mailingAddressCity",
    MAI: "mailingAddressJurisdiction",
    MAO: "mailingAddressZip",
  },
  IR: {
    RBC: "registrantName",
    RBI: "physicalAddressStreet",
    RBK: "physicalAddressCity",
    RBL: "physicalAddressJurisdiction",
    RBM: "physicalAddressZip",
    IEG: "unitNumber",
    VAD: "vin",
    VAL: "modelYear",
    VAK: "vehicleMake",
    VBB: "vehicleType",
    RAP: "seatsAxles",
    //or
    VBC: "seatsAxles",
    RBT: "registrationYear",
    IFJ: "registrationIssueDate",
    RAM: "plateNumber",
    RAD: "plateDecal",
    RAF: "enforcementDate",
    RAG: "registrationExpirationDate",
    VAT: "grossVehicleWeight",
    RAU: "baseStateRegisteredWeight",
  },
  RW: {
    WAB: "AB",
    WAL: "AL",
    WAR: "AR",
    WAZ: "AZ",
    WBC: "BC",
    WCA: "CA",
    WCO: "CO",
    WCT: "CT",
    WDC: "DC",
    WDE: "DE",
    WFL: "FL",
    WGA: "GA",
    WIA: "IA",
    WID: "ID",
    WIL: "IL",
    WIN: "IN",
    WKS: "KS",
    WKY: "KY",
    WLA: "LA",
    WMA: "MA",
    WMB: "MB",
    WMD: "MD",
    WME: "ME",
    WMI: "MI",
    WMN: "MN",
    WMO: "MO",
    WMS: "MS",
    WMT: "MT",
    WNB: "NB",
    WNC: "NC",
    WND: "ND",
    WNE: "NE",
    WNF: "NF",
    WNL: "NL",
    WNH: "NH",
    WNJ: "NJ",
    WNM: "NM",
    WNS: "NS",
    WNV: "NV",
    WNY: "NY",
    WOH: "OH",
    WOK: "OK",
    WON: "ON",
    WOR: "OR",
    WPA: "PA",
    WPE: "PE",
    WQC: "QC",
    WRI: "RI",
    WSC: "SC",
    WSD: "SD",
    WSK: "SK",
    WTN: "TN",
    WTX: "TX",
    WUT: "UT",
    WVA: "VA",
    WVT: "VT",
    WWA: "WA",
    WWI: "WI",
    WWV: "WV",
    WWY: "WY",
  }
}

// Leaving this here for reference and possible future use
// const REGISTRATION_CODES_DESCRIPTIONS = {
//   MC: {
//     MAN: "US DOT Number of the carrier responsible for safety",
//     MAA: "Name of the carrier responsible for safety",
//     MAK: "Mailing Address, Street 1",
//     MAL: "Mailing Address, City",
//     MAI: "Mailing Address, Jurisdiction",
//     MAO: "Mailing Address, Postal/Zip Code",
//   },
//   IR: {
//     RBC: "Registrant Name",
//     RBI: "Physical Address, Street 1",
//     RBK: "Physical Address, City",
//     RBL: "Physical Address, Jurisdiction",
//     RBM: "Physical Address, Postal/Zip Code",
//     IEG: "Unit number",
//     VAD: "Vehicle Identification Number",
//     VAL: "Vehicle Model Year – Format=YY",
//     VAK: "Vehicle Make",
//     VBB: "Vehicle Type",
//     RAP: "Number of Seats/Axles",
//     //or
//     VBC: "Number of Seats/Axles",
//     RBT: "Registration Year – Format CCYY",
//     IFJ: "IRP Registration Issue Date – Format=CCYYMMDD",
//     RAM: "IRP License Plate Number",
//     RAD: "IRP Registration Plate Decal",
//     RAF: "Enforcement Date – Format=CCYYMMDD",
//     RAG: "IRP Registration Expiration Date – Format=CCYYMMDD",
//     VAT: "Gross Vehicle Weight",
//     RAU: "Base State Registered Weight",
//   },
//   RW: {
//     WAB: "Alberta Registered Weight",
//     WAL: "Alabama Registered Weight",
//     WAR: "Arkansas Registered Weight",
//     WAZ: "Arizona Registered Weight",
//     WBC: "British Columbia Registered Weight",
//     WCA: "California Registered Weight",
//     WCO: "Colorado Registered Weight",
//     WCT: "Connecticut Registered Weight",
//     WDC: "District of Columbia Registered Weight",
//     WDE: "Delaware Registered Weight",
//     WFL: "Florida Registered Weight",
//     WGA: "Georgia Registered Weight",
//     WIA: "Iowa Registered Weight",
//     WID: "Idaho Registered Weight",
//     WIL: "Illinois Registered Weight",
//     WIN: "Indiana Registered Weight",
//     WKS: "Kansas Registered Weight",
//     WKY: "Kentucky Registered Weight",
//     WLA: "Louisiana Registered Weight",
//     WMA: "Massachusetts Registered Weight",
//     WMB: "Manitoba Registered Weight",
//     WMD: "Maryland Registered Weight",
//     WME: "Maine Registered Weight",
//     WMI: "Michigan Registered Weight",
//     WMN: "Minnesota Registered Weight",
//     WMO: "Missouri Registered Weight",
//     WMS: "Mississippi Registered Weight",
//     WMT: "Montana Registered Weight",
//     WNB: "New Brunswick Registered Weight",
//     WNC: "North Carolina Registered Weight",
//     WND: "North Dakota Registered Weight",
//     WNE: "Nebraska Registered Weight",
//     WNF: "Newfoundland Registered Weight",
//     WNH: "New Hampshire Registered Weight",
//     WNJ: "New Jersey Registered Weight",
//     WNM: "New Mexico Registered Weight",
//     WNS: "Nova Scotia Registered Weight",
//     WNV: "Nevada Registered Weight",
//     WNY: "New York Registered Weight",
//     WOH: "Ohio Registered Weight",
//     WOK: "Oklahoma Registered Weight",
//     WON: "Ontario Registered Weight",
//     WOR: "Oregon Registered Weight",
//     WPA: "Pennsylvania Registered Weight",
//     WPE: "Prince Edward Island Registered Weight",
//     WQC: "Quebec Registered Weight",
//     WRI: "Rhode Island Registered Weight",
//     WSC: "South Carolina Registered Weight",
//     WSD: "South Dakota Registered Weight",
//     WSK: "Saskatchewan Registered Weight",
//     WTN: "Tennessee Registered Weight",
//     WTX: "Texas Registered Weight",
//     WUT: "Utah Registered Weight",
//     WVA: "Virginia Registered Weight",
//     WVT: "Vermont Registered Weight",
//     WWA: "Washington Registered Weight",
//     WWI: "Wisconsin Registered Weight",
//     WWV: "West Virginia Registered Weight",
//     WWY: "Wyoming Registered Weight",
//   }
// }